
    import './styles.scoped.css';
    export default {
  "items-loader": "awsui_items-loader_115pt_16l07_5"
};
  